var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff4e4e;}.b{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1192 -2535)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(-1192 2535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.766,14.766a.8.8,0,0,1-1.131,0L11,12.131,8.366,14.766a.8.8,0,0,1-1.131-1.131L9.869,11,7.234,8.366A.8.8,0,0,1,8.366,7.234L11,9.869l2.634-2.634a.8.8,0,1,1,1.131,1.131L12.131,11l2.634,2.634A.8.8,0,0,1,14.766,14.766Z",
    transform: "translate(-1195 2532)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleRed);
export default __webpack_public_path__ + "static/media/cross-circle-red.46d6fe0aaff4526d81c1a8e0ec65e3a9.svg";
export { ForwardRef as ReactComponent };